import { render, staticRenderFns } from "./Layer.vue?vue&type=template&id=febca46c"
import script from "./Layer.vue?vue&type=script&lang=js"
export * from "./Layer.vue?vue&type=script&lang=js"
import style0 from "./Layer.vue?vue&type=style&index=0&id=febca46c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports